export const CrearCotizacion = "CrearCotizacion";
export const ActualizarCotizacion = "ActualizarCotizacion";
export const BuscarCotizacionActual = "BuscarCotizacionActual";
export const BuscarCotizacionPorCliente = "BuscarCotizacionPorCliente";
export const Cargando = "COTIZACION_CARGANDO";
export const Error = "COTIZACION_ERROR";
